var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTenantNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_725_404",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_725_404",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB90lEQVR4nO2dQUoDQRRE+wB6DPUObkT75wheQKS/uNd4GJPgNmdRbxRGekDQje6mKvR7UOsw9aZ7hqHJLwUAAAAAAAAAAABAxvXDRYm2LrXtSs39WGm7cpPPpd6fFzmXd6cl2lup7VAip6FT22GWc/V4opTxKS8i7PKhkdJXhv7iJ8v0lbL4M4NtavpDyGHZZ0q0F/ldGO5p6+WE9CUpv+A0T9ssKCT3+gtO7/SOEJJ6EQhJffkISX3hCEl9yQhJfbEISX2ZCDEoMBCiLy0Qoi8qEKIvJxCiLyQQoi8hjMK3rNRLQEjqi0dI6ss+KiHyYzm5bOyFjEYgxAuEmIEQMxBiBkLMQIgZCDEDIWbYC1m126ES7kLIhJAwvBFYIamXgJDUF4+Q1JeNkNQXfLRC1K+hK157fwsZjXBfIaMRCPECIWYgxAyEmIEQMxBiBkLMsBeiPtpZOUqq/24UhrFZIWRCSBjeCKyQ1EtASOqLR0jqyz4qIaMRCPECIWYgxAyEmIEQMxBiBkLMQIgZCDHDQkj/o3n1p4lwT3tdUgjjKuIfIX0u1WL0YSUMdJl8BrrMUpghUixmh3zTB1/1AVjyvTq9Utu7blJb/+F5diFj88rcQdvoZPyk75fzcMXcyo/l1MWzLbU9lcgztQYAAAAAAAAAAAAo4/IF16qWSbNDEs8AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantNotes);
export default __webpack_public_path__ + "static/media/tenantNotes.04ffce3cf31a97af529bf73da9004599.svg";
export { ForwardRef as ReactComponent };